import { validations } from "../../../../../config/validations/validations";
import { maxCode, minCode } from "../../../../../config/Validators";

export const rules: any = {
  code: () => [
    validations.required.text(),
    validations.min.text(minCode),
    validations.max.text(maxCode),
  ],
};
